// extracted by mini-css-extract-plugin
export var indeterminate = "_42-5";
export var md = "_42-4";
export var semantic = "_42-6";
export var sm = "_42-3";
export var text = "_42-7";
export var toggleInput = "_42-0";
export var toggleSwitch = "_42-1";
export var xs = "_42-2";